module.exports = __webpack_public_path__ + "img/08.bebf3ab7.jpg";